import { makeStyles } from '@material-ui/styles';

import { orange, yellow } from 'shared/styles/colors';

export default makeStyles({
  alert: {
    padding: '0.5rem 0.75rem',
    marginBottom: '0.5rem',
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: orange[70],
    backgroundColor: yellow[10],
  },
  info: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    '& > dl > div': {
      display: 'flex',
      gap: '0.25rem',
    },
  },
});
